/// <amd-module name="TFS/Admin/OrganizationAadPolicyControls/Components/AddAadGroupPanel" />
import React = require("react");
import { IVssPageContext } from "VSS/Platform/Context";

import AdminResources = require("TFS/Admin/OrganizationAadPolicyControls/Resources");
import { IButtonProps } from "VSSUI/Button";
import { Panel } from "VSSUI/Panel";
import { ContentSize } from "VSSUI/Callout";
import { VssComponent } from "VSS/Platform/Layout";
import { IdentityPicker, IIdentity } from "VSSUI/IdentityPicker";
import { PeoplePickerProvider } from "VSS/Features/Identities/IdentityPickerProvider";
import { ObservableArray } from "VSS/Core/Observable";
import { IAddAadGroupPanelComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/AadPolicyControls.props";

export interface IAddAadGroupPanelComponentState {
    hasAddedUserOrGroup: boolean;
}

export class AddAadGroupPanelComponent extends React.Component<IAddAadGroupPanelComponentProps, IAddAadGroupPanelComponentState> {
    private selectedIdentities = new ObservableArray<IIdentity>([]);
    public constructor(props: IAddAadGroupPanelComponentProps) {
        super(props);

        this.state = {
            hasAddedUserOrGroup: false
        };
    }
    public render(): JSX.Element {
        const footerButtons: IButtonProps[] = [
            {
                onClick: this.props.onDismiss,
                text: AdminResources.CancelButton
            },
            {
                className: "primary-action-button",
                onClick: () => {
                    this.props.onAddAadGroups(this.selectedIdentities.value);
                },
                disabled: !this.state.hasAddedUserOrGroup,
                primary: true,
                text: AdminResources.AddButton
            }
        ];

        return (
            <Panel
                onDismiss={this.props.onDismiss}
                titleProps={{ text: AdminResources.AddAADGroupTitle }}
                size={ContentSize.Medium}
                footerButtonProps={footerButtons}
            >
                {this._renderPanelBody()}
            </Panel>
        );
    }

    private _renderPanelBody(): JSX.Element {
        const peoplePickerProvider = new PeoplePickerProvider(this.props.pageContext, {
            options: {
                MinResults: 5,
                MaxResults: 20
            },
            identityTypes: ["group", "user"],
            operationScopes: ["source"]
        });
        return (
            <div className="width-100">
                <div>{AdminResources.SearchGroups}</div>
                <div className="add-aad-group-people-picker width-100">
                    <IdentityPicker
                        onIdentitiesRemoved={this._onIdentitiesRemoved}
                        onIdentityAdded={this._onIdentityAdded}
                        onIdentityRemoved={this._onIdentityRemoved}
                        pickerProvider={peoplePickerProvider}
                        selectedIdentities={this.selectedIdentities}
                        placeholderText={AdminResources.SearchUserOrGroup}
                    />
                </div>
            </div>
        );
    }

    private _onIdentitiesRemoved = (identities: IIdentity[]) => {
        this.selectedIdentities.value = this.selectedIdentities.value.filter(
            (entity: IIdentity) => identities.filter(item => item.entityId === entity.entityId).length === 0
        );
        if (!this.selectedIdentities.value || this.selectedIdentities.value.length == 0) {
            this.setState({ hasAddedUserOrGroup: false });
        }
    };

    private _onIdentityAdded = (identity: IIdentity) => {
        this.selectedIdentities.value.push(identity);
        this.setState({ hasAddedUserOrGroup: true });
    };

    private _onIdentityRemoved = (identity: IIdentity) => {
        this.selectedIdentities.value = this.selectedIdentities.value.filter((entity: IIdentity) => entity.entityId !== identity.entityId);
        if (!this.selectedIdentities.value || this.selectedIdentities.value.length == 0) {
            this.setState({ hasAddedUserOrGroup: false });
        }
    };
}

VssComponent.register("ms.vss-admin-web.aad-policy-add-group-panel", AddAadGroupPanelComponent);
